import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SettingComponent } from './setting/setting.component';
import { LogoutComponent } from './logout/logout.component';
import { LoginComponent } from './login/login.component'
import { AuthGuardService } from './guards/auth.guard.service';
import { LogsComponent } from './logs/logs.component';
import { StatusComponent } from './status/status/status.component';
//import { ResetPasswordComponent } from './reset-password/reset-password.component';

const routes: Routes = [

  { path: 'login', component: LoginComponent },
  { path: 'customers', loadChildren: () => import('./customer/customer.module').then(m => m.CustomerModule), canActivate: [AuthGuardService] },
  { path: 'vendors', loadChildren: () => import('./vendors/vendors.module').then(m => m.VendorsModule) },
  /* { path: 'signup', component: SignUpComponent }, */

  { path: 'status', component: StatusComponent },
  { path: 'logs', component: LogsComponent },
  { path: 'setting', component: SettingComponent, canActivate: [AuthGuardService] },
  { path: 'logout', component: LogoutComponent },
  //{ path: 'forgotPassword', component: ResetPasswordComponent },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

